<script setup lang="ts">
import Lucide from "@/components/Base/Lucide";
import { computed } from "vue";

const props = defineProps({
  title: String,
  value: [String, Number],
  icon: String,
  variant: {
    type: String,
    default: "primary"
  },
  subValue: String // e.g. "active"
});

// Map variant to colors
const colorClass = computed(() => {
    switch(props.variant) {
        case 'success': return 'bg-success/20 text-success';
        case 'warning': return 'bg-warning/20 text-warning';
        case 'danger': return 'bg-danger/20 text-danger';
        case 'info': return 'bg-info/20 text-info';
        case 'purple': return 'bg-purple-100 text-purple-600';
        case 'primary': default: return 'bg-primary/20 text-primary';
    }
});
</script>

<template>
  <div class="box p-5 zoom-in">
    <div class="flex">
        <div class="mr-auto">
            <div class="text-slate-500 text-base font-medium mb-1">{{ title }}</div>
            <div class="text-3xl font-bold leading-8">{{ value }}</div>
            <div v-if="subValue" class="text-xs text-slate-400 mt-1">{{ subValue }}</div>
        </div>
        <div class="flex items-center justify-center w-12 h-12 rounded-full" :class="colorClass">
            <Lucide :icon="icon" class="w-6 h-6" />
        </div>
    </div>
  </div>
</template>
